import jquery from 'jquery';

// The legacy feature modules use the jQuery global. Keep this explicit runtime
// contract without loading Bootstrap or Bootstrap Material.
window.$ = jquery;
window.jQuery = jquery;

// These UMD plugins inspect the browser globals while they initialise. Use
// runtime requires so the globals above exist before any plugin factory runs.
require('datatables.net');
require('./_asscrollbar');
require('./_asscrollable');
require('./_slidepanel');
require('jquery-mousewheel');
require('jquery-mask-plugin');
require('sly/dist/sly.js');
require('jstree');
